import { useState } from "react";
import { post } from "../../utils/api";
import { toast } from "react-toastify";
import InputText from "../../customComponents/InputText";
import Upload from "../../customComponents/Upload";
import ItineraryPicker from "./ItineraryPicker";

const GroupModal = ({ editTarget, onClose, onSaved }) => {
  const [name, setName] = useState(editTarget?.name || "");
  const [coverImageUrl, setCoverImageUrl] = useState(editTarget?.cover_image_url || null);
  const [isActive, setIsActive] = useState(editTarget?.is_active ?? true);
  const [items, setItems] = useState(editTarget?.items || []);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Name is required");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...(editTarget?.id ? { id: editTarget.id } : {}),
        name: name.trim(),
        cover_image_url: coverImageUrl || null,
        is_active: isActive,
        items: items.map((item) => ({
          itinerarydetailsid: item.itinerarydetailsid,
          display_order: item.display_order,
        })),
      };
      await post("/cms/group/save", payload);
      toast.success(editTarget ? "Category updated" : "Category created");
      onSaved();
    } catch {
      toast.error("Save failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">
            {editTarget ? "Edit Category" : "Add Category"}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl">
            ×
          </button>
        </div>

        <div className="space-y-4">
          <InputText
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Beach Getaways"
          />

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Cover Image
            </label>
            <Upload
              labelText="Upload Cover"
              initialPreviewUrl={coverImageUrl}
              uploadEndpoint="/api/dashboard/upload/cms-image"
              onFileSelect={(url) => setCoverImageUrl(url)}
              handleRemove={() => setCoverImageUrl(null)}
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="group-active"
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              className="w-4 h-4"
            />
            <label htmlFor="group-active" className="text-sm text-gray-700">
              Active
            </label>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Itineraries
            </label>
            <ItineraryPicker selectedItems={items} onChange={setItems} />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="px-4 py-2 text-sm text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupModal;
